import { render, staticRenderFns } from "./DescargoRevPage.vue?vue&type=template&id=d202200e"
import script from "./DescargoRevPage.js?vue&type=script&lang=js&external"
export * from "./DescargoRevPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports